// Overview subsection form field enum
export enum OverviewFormField {
  OVERVIEW_ROC_DATE = 'resumption-overview/roc-date',
  OVERVIEW_INPATIENT_DISCHARGE_DATE = 'resumption-overview/inpatient-discharge-date',
  OVERVIEW_REASON_FOR_INPATIENT_STAY = 'resumption-overview/reason-for-inpatient-stay',
  OVERVIEW_INPATIENT_DISCHARGE_INSTRUCTIONS = 'resumption-overview/inpatient-discharge-instructions',
  OVERVIEW_COMMENTS = 'resumption-overview/comments'
}
